// src/store/store.js
import { createStore } from 'vuex';

export const store = createStore({
    state: {
        user: JSON.parse(localStorage.getItem('bk_admin_user')) || null,
        token: localStorage.getItem('bk_admin_token') || null,
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
        setToken(state, token) {
            state.token = token;
        },
        logout(state) {
            state.user = null;
            state.token = null;
        },
    },
    actions: {
        login({ commit }, { user, token }) {
            commit('setUser', user);
            commit('setToken', token);
            localStorage.setItem('bk_admin_token', token);
            localStorage.setItem('bk_admin_user', JSON.stringify(user));
        },
        logout({ commit }) {
            commit('logout');
            localStorage.removeItem('bk_admin_token');
            localStorage.removeItem('bk_admin_user');
        },
        checkLogin({ commit }) {
            const token = localStorage.getItem('bk_admin_token');
            const user = JSON.parse(localStorage.getItem('bk_admin_user'));
            if (token && user) {
                commit('setUser', user);
                commit('setToken', token);
            }
        },
    },
    getters: {
        token: (state) => state.token,
        isLoggedIn: (state) => !!state.user,
    },
});
